
























import { Vue, Component, Prop } from 'vue-property-decorator';
import BaseButtonIcon from '@lib-ui/components/base-button-icon/_base-button-icon.vue';
import BaseIcon from '@lib-ui/components/base-icon/_base-icon.vue';

@Component({
  components: {
    BaseButtonIcon,
    BaseIcon,
  },
})
export default class PromptBar extends Vue {
  @Prop({ default: true }) showProgressBar: boolean;
  @Prop({ default: false }) closable: boolean;

  handleClose() {
    this.$emit('close');
  }
}
